import { useNavigate } from "react-router-dom";
import { getPriceString } from "../utils/getPriceString";
import { setBacklink } from "../redux/backlinkSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

const BookForm = ({ activityId, priceArray, priceNote, isPremium, isRequestDone, isExternalPaid }) => {
    const { t } = useTranslation();

    // Indirizzo l'utente alla pagina d'acquisto (verranno verificatii suoi dati col middleware UserPurchaseDataCheck)
    const { isUserPurchaseAvailable } = useSelector(state => state.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const goToSendRequest = () => {
        dispatch(setBacklink(`/activity-details?id=${activityId}`))
        navigate(`/send-request/${activityId}`)
    }

    return (
        <div className={`w-full xl:w-[300px] min-h-[200px] h-fit border rounded-xl shadow-xl p-4 flex flex-col items-center gap-8 bg-neutral-100`}>
            {/* Price */}
            {!isExternalPaid && priceArray.length > 0 && <div className='mt-8 flex flex-col gap-2 border border-[#225424] p-2 rounded-xl w-full'>
                <i className="fi fi-rs-coins"></i>
                {
                    priceArray.map((element, index) => {
                        return <h4 key={index}>{getPriceString(element.value, element.people)}</h4>
                    })
                }
                {priceNote && <h5 className='italic'>({priceNote})</h5>}
            </div>}

            {/* BUTTON PRENOTA */}
            {
                !isExternalPaid &&
                isPremium &&
                !isRequestDone &&
                <button className="w-full bg-[#225424] flex gap-2 items-center justify-center py-3 px-4 text-white rounded-xl" onClick={goToSendRequest}>
                    <div className='pt-0.5'><i className="fi fi-rr-calendar-check"></i></div>
                    <div>{t('ActivityDetails.BookForm.book')}</div>
                </button>
            }
            {
                !isExternalPaid &&
                isPremium &&
                isRequestDone &&
                <div className="w-full p-4 border-2 border-[#225424] bg-green-100 rounded-xl">
                    {t('ActivityDetails.BookForm.requestAlreadySent')}
                </div>
            }

            {
                !isExternalPaid &&
                !isPremium &&
                <div className="text-center font-bold text-[#225424]">{t('ActivityDetails.BookForm.freeActivity')}</div>
            }
            {
                isExternalPaid &&
                <div className="flex flex-col gap-2 text-center">
                    <div className="font-bold text-[#225424]">{t('ActivityDetails.BookForm.isExternalPaid1')}</div>
                    <div className="italic font-extralight">{t('ActivityDetails.BookForm.isExternalPaid2')}</div>
                </div>
            }
        </div>
    )
}

export default BookForm;